export const googleAnalyticsConfig = {
  trackingId: 'G-13H3H70FWJ',
};
